import React from "react";
import { Brain } from 'lucide-react';
import { NavItem } from "../NavItem";

export function MlDetectionLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/mldetection"
            Icon={Brain}
            label="ML Detection"
            isCollapsed={isCollapsed}
        />
    );
}